import { FieldShell } from './FieldShell';
import { useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

/*
    🔥 SLIDER

    El input[type=range] nativo se estila con ::-webkit-slider-thumb y
    ::-moz-range-thumb. El relleno de la izquierda no existe en CSS:
    se dibuja con un degradado calculado según el valor.
*/

export const FieldRange = ({
    id, name, label, hint, error,
    value = 0, onChange,
    min = 0, max = 100, step = 1,
    showValue = true, formatValue = null,
    isDisabled = false, span = 1, ...rest
}) => {

    const PERCENT = ((Number(value) - min) * 100) / (max - min || 1);

    const TEXT = formatValue ? formatValue(value) : value;

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} hint={hint} error={error}
            isDisabled={isDisabled} span={span} >

            <div className={`${BLOCK}__range`}>

                <input id={DOM_ID} data-field={name ?? id} name={name ?? id} type="range"
                    className={`${BLOCK}__range_input`}
                    style={{ '--LS__range_percent': `${PERCENT}%` }}
                    value={value} onChange={onChange}
                    min={min} max={max} step={step} disabled={isDisabled}
                    {...rest} />

                {showValue && <output className={`${BLOCK}__range_value`}>{TEXT}</output>}

            </div>

        </FieldShell>
    );
};
